import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { IncomingInvoicesDetailsTable } from "./tables/IncomingInvoicesDetails.table";

export function IncomingInvoicesDetailsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <IncomingInvoicesDetailsTable />
        <Toast />
      </Dashboard>
    </ToastProvider>
  );
}
